import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { Address, BaseQueryParams, IResponsePaginate, AddressDto } from '@/types';

interface AddressQuery extends BaseQueryParams {
  address?: string;
}

@Injectable({
  providedIn: 'root',
})
export class AddressService {
  BASEURL = `${environment.api.paramsUrl}/societe_address`;
  httpClient = inject(HttpClient);

  getAddresses(params?: AddressQuery): Observable<IResponsePaginate<Address>> {
    return this.httpClient.get<IResponsePaginate<Address>>(`${this.BASEURL}`, { params: params as HttpParams });
  }

  addAddress(address: AddressDto): Observable<Address> {
    return this.httpClient.post<Address>(`${this.BASEURL}`, address);
  }

  updateAddress(id: number, address: AddressDto): Observable<Address> {
    return this.httpClient.put<Address>(`${this.BASEURL}/${id}`, address);
  }

  deleteAddress(id: number): Observable<Address> {
    return this.httpClient.delete<Address>(`${this.BASEURL}/${id}`);
  }
}
